import React from 'react';
import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js';

interface PayPalCheckoutProps {
    amount: number;
    currency?: string;
    onSuccess: (details: any) => void;
    onError: (error: any) => void;
    onCancel: () => void;
}

const PayPalCheckout: React.FC<PayPalCheckoutProps> = ({
    amount,
    currency = 'USD',
    onSuccess,
    onError,
    onCancel
}) => {
    const clientId = process.env.REACT_APP_PAYPAL_CLIENT_ID;

    if (!clientId) {
        return (
            <div style={{ padding: '20px', textAlign: 'center', color: '#dc2626' }}>
                <p>⚠️ PayPal Client ID not configured</p>
                <p style={{ fontSize: '12px', marginTop: '8px' }}>
                    Please add REACT_APP_PAYPAL_CLIENT_ID to your .env file
                </p>
            </div>
        );
    }

    const initialOptions = {
        clientId: clientId,
        currency: currency,
        intent: 'capture',
    };

    return (
        <PayPalScriptProvider options={initialOptions}>
            <PayPalButtons
                style={{
                    layout: 'vertical',
                    color: 'gold',
                    shape: 'rect',
                    label: 'paypal',
                }}
                createOrder={(data, actions) => {
                    return actions.order.create({
                        intent: 'CAPTURE',
                        purchase_units: [
                            {
                                amount: {
                                    value: amount.toString(),
                                    currency_code: currency,
                                },
                            },
                        ],
                    });
                }}
                onApprove={async (data, actions) => {
                    if (actions.order) {
                        const details = await actions.order.capture();
                        onSuccess(details);
                    }
                }}
                onError={(error) => {
                    console.error('PayPal Error:', error);
                    onError(error);
                }}
                onCancel={() => {
                    console.log('PayPal payment cancelled');
                    onCancel();
                }}
            />
        </PayPalScriptProvider>
    );
};

export default PayPalCheckout;
